import React, { useEffect, useState } from 'react';
import { FormControl, Input } from 'rsuite';
import { useDebouncedCallback } from 'use-debounce';
import { useLocation } from '../hooks/useLocation';

export const FilterText = ({ name, placeholder }) => {
  const { params, go } = useLocation();

  const [v, setV] = useState('');
  // const scope = useContext(EquipmentContext);

  const { category, page, order, view, ...filters } = params;

  let filtersServer = { ...filters };
  delete filtersServer[name];

  const update = useDebouncedCallback((v) => {
    const vals = { [name]: v };

    go({ ...params, ...vals });
  }, 500);

  useEffect(() => update.callback(v), [update, v]);

  const value = v || '';
  // const value = params[name] || '';

  return (
    <FormControl
      className="filter"
      placeholder={placeholder}
      accepter={Input}
      value={value}
      onChange={(v) => {
        setV(v ? v : null);
      }}
    />
  );
};
